import { useEffect, useState } from "react";
import "./IngresoReportes.css"
import "../../paginas/Reportes/reportes.css";
import { useStoreReportes } from "../../paginas/Reportes/useStoreReportes.js";
import Calendario from "../../ComponentesGlobales/Calendario.jsx";
import { Chart } from 'primereact/chart';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useStoreHome } from "../../paginas/Home/useStoreHome.js";
import { enumReporteSeleccionado } from "../FuncionesLocales.js";
import ExportarReporte from "../ExportarReporte/ExportarReporte.jsx";
import { formatearFechaExportacion } from "../../servicios/reportesExportacion.js";
import TipoProductoFiltro from "../TipoProductoFiltro/TipoProductoFiltro.jsx";
import {
  limpiarCantidadDeDescripcion,
  obtenerCantidadIngreso,
} from "./ingresosReportesUtils.js";

const CHART_COLOR_TOKENS = [
  ["--app-brand-deep", "#244537"],
  ["--app-brand-dark", "#315b49"],
  ["--app-brand", "#477c63"],
  ["--app-accent", "#73a98d"],
  ["--app-warning", "#946b22"],
  ["--app-danger", "#a23c35"],
  ["--app-brand-border", "#c8ddd0"],
  ["--app-brand-soft", "#e7f1eb"],
];

const leerColorTema = (styles, token, fallback) =>
  styles.getPropertyValue(token).trim() || fallback;

const obtenerPaletaGraficos = (styles) =>
  CHART_COLOR_TOKENS.map(([token, fallback]) => leerColorTema(styles, token, fallback));
const IngresosReportes = () => {
  const ListaIngresadoPorProveedor = useStoreReportes((state) => state.ListaIngresadoPorProveedor);
  const BuscandoIngresos = useStoreReportes((state) => state.BuscandoIngresos);
  const FechaDesde = useStoreReportes((state) => state.FechaDesde);
  const FechaHasta = useStoreReportes((state) => state.FechaHasta);
  const Lote = useStoreReportes((state) => state.Lote);
  const TipoProducto = useStoreReportes((state) => state.TipoProducto);

  const [chartData] = useState({});
  const [chartsByUnit, setChartsByUnit] = useState({});
  const [proveedorPieChartsByUnit, setProveedorPieChartsByUnit] = useState({});




  useEffect(() => {
    useStoreReportes.getState().getIngresados();
  }, [FechaDesde, FechaHasta, Lote, TipoProducto]);

  useEffect(() => {
    useStoreHome.setState({ ReportesSeleccionado: enumReporteSeleccionado.INGRESOS });
    useStoreReportes.getState().getStock();
  }, []);



  // Nuevo useEffect para agrupar por UnidadDescripcion
  useEffect(() => {
    if (ListaIngresadoPorProveedor && ListaIngresadoPorProveedor.length > 0) {
      // Agrupar datos por UnidadDescripcion
      const groupedByUnit = ListaIngresadoPorProveedor.reduce((acc, item) => {
        const unidad = item.UnidadDescripcion || 'Sin unidad';
        if (!acc[unidad]) {
          acc[unidad] = [];
        }
        acc[unidad].push(item);
        return acc;
      }, {});

      // Crear gráficos para cada unidad
      const chartsByUnitData = {};
      const documentStyle = getComputedStyle(document.documentElement);
      const colors = obtenerPaletaGraficos(documentStyle);
      const textColor = leerColorTema(documentStyle, '--app-ink', '#294438');
      const textColorSecondary = leerColorTema(documentStyle, '--app-muted', '#687870');
      const surfaceBorder = leerColorTema(documentStyle, '--app-border', '#dce6df');

      Object.keys(groupedByUnit).forEach((unidad) => {
        const unitData = groupedByUnit[unidad];
        const labels = unitData.map(item => limpiarCantidadDeDescripcion(item.sDescripcion || item.Proveedor || 'Proveedor'));
        const pesoData = unitData.map(obtenerCantidadIngreso);

        chartsByUnitData[unidad] = {
          data: {
            labels: labels,
            datasets: [
              //   {
              //   label: 'Bultos',
              //   backgroundColor: colors[0],
              //   borderColor: colors[0],
              //   data: stockData
              // },
              {
                label: unidad,
                backgroundColor: colors,
                borderColor: colors,
                hoverBackgroundColor: colors,
                data: pesoData
              }]
          },
          options: {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
              legend: {
                labels: {
                  color: textColor
                }
              },
              title: {
                display: true,
                text: `Ingresos - ${unidad}`,
                color: textColor,
                font: {
                  size: 20,
                  weight: 'bold'
                }
              }
            },
            scales: {
              x: {
                ticks: {
                  color: textColorSecondary,
                  font: {
                    weight: 500
                  },
                  maxRotation: 90,
                  minRotation: 0
                },
                grid: {
                  display: true,
                  drawBorder: true
                }
              },
              y: {
                ticks: { color: textColorSecondary },
                grid: { color: surfaceBorder, drawBorder: false }
              }
            }
          }
        };
      });

      setChartsByUnit(chartsByUnitData);
    } else {
      setChartsByUnit({});
    }
  }, [ListaIngresadoPorProveedor]);

  // useEffect para crear gráficos de torta por ProveedorDescripcion para cada unidad
  useEffect(() => {
    if (ListaIngresadoPorProveedor && ListaIngresadoPorProveedor.length > 0) {
      // Agrupar datos por UnidadDescripcion
      const groupedByUnit = ListaIngresadoPorProveedor.reduce((acc, item) => {
        const unidad = item.UnidadDescripcion || 'Sin unidad';
        if (!acc[unidad]) {
          acc[unidad] = [];
        }
        acc[unidad].push(item);
        return acc;
      }, {});

      const pieChartsByUnitData = {};
      const documentStyle = getComputedStyle(document.documentElement);
      const colors = obtenerPaletaGraficos(documentStyle);
      const textColor = leerColorTema(documentStyle, '--app-ink', '#294438');
      Object.keys(groupedByUnit).forEach((unidad) => {
        const unitData = groupedByUnit[unidad];

        // Agrupar por ProveedorDescripcion dentro de esta unidad
        const proveedorGroups = unitData.reduce((acc, item) => {
          const proveedor = item.Proveedor || 'Sin proveedor';
          if (!acc[proveedor]) {
            acc[proveedor] = {
              proveedor: proveedor,
              totalPeso: 0,
              totalUnidades: 0
            };
          }
          acc[proveedor].totalPeso += obtenerCantidadIngreso(item);
          acc[proveedor].totalUnidades += Number(item.Unidades || 0);
          return acc;
        }, {});

        const proveedorData = Object.values(proveedorGroups);

        // Crear datos para el gráfico de torta por peso
        const pieDataPeso = {
          labels: proveedorData.map(item => item.proveedor),
          datasets: [{
            data: proveedorData.map(item => item.totalPeso),
            backgroundColor: colors,
            hoverBackgroundColor: colors,
            borderColor: '#ffffff',
            borderWidth: 1
          }]
        };

        // Crear datos para el gráfico de torta por unidades
        const pieDataUnidades = {
          labels: proveedorData.map(item => item.proveedor),
          datasets: [{
            data: proveedorData.map(item => item.totalUnidades),
            backgroundColor: colors,
            hoverBackgroundColor: colors,
            borderColor: '#ffffff',
            borderWidth: 1
          }]
        };

        const pieOptions = {
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                color: textColor,
                usePointStyle: true,
                padding: 15,
                font: {
                  size: 11
                }
              }
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  const label = context.label || '';
                  const value = context.parsed;
                  const total = context.dataset.data.reduce((acc, curr) => acc + curr, 0);
                  const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
                  return `${label}: ${value.toFixed(2)} (${percentage}%)`;
                }
              }
            }
          },
          maintainAspectRatio: false
        };

        pieChartsByUnitData[unidad] = {
          peso: { data: pieDataPeso, options: pieOptions },
          unidades: { data: pieDataUnidades, options: pieOptions }
        };
      });

      setProveedorPieChartsByUnit(pieChartsByUnitData);
    } else {
      setProveedorPieChartsByUnit({});
    }
  }, [ListaIngresadoPorProveedor]);

  //  console.log(ListaIngresadoPorProveedor);

  return (
    <div style={{ padding: "8px" }}>
      <h2 className="titulo-p">Ingresos</h2>

      <div className="reportes-exportacion">
        <TipoProductoFiltro />
        <ExportarReporte
          endpoint="PISeunReportes/ListaIngresado"
          nombre="Ingresos"
          filters={{ FechaDesde: formatearFechaExportacion(FechaDesde), FechaHasta: formatearFechaExportacion(FechaHasta), Lote: Lote || "", TipoProducto }}
        />
      </div>

      <div className="filtros-fecha" >
        <div>
          <span style={{ marginTop: 10, marginRight: 10 }}>Desde: </span>
          <Calendario
            Fecha={FechaDesde}
            setFecha={(fecha) => useStoreReportes.setState({ FechaDesde: fecha })}
          />
        </div>
        <div>
          <span style={{ marginTop: 10, marginRight: 10 }}>Hasta:</span>
          <Calendario
            Fecha={FechaHasta}
            setFecha={(fecha) => useStoreReportes.setState({ FechaHasta: fecha })}
          />
        </div>
      </div>

      {/* <div className="filtros-fecha" >
        <div>
          <span style={{ marginTop: 10, marginRight: 10 }}>Lote: </span>
          <input
            type="text"
            value={Lote}
            onChange={(e) => useStoreReportes.setState({ Lote: e.target.value })}
            placeholder="Lote"
          />
        </div>
      </div> */}

      <div className="reportes-container">
        <div className="graficos-reportes">

          {/* Gráficos por unidad de medida */}
          {BuscandoIngresos ? (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
              <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" />
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              {Object.keys(chartsByUnit).length > 0 ? (
                Object.keys(chartsByUnit).map((unidad) => {
                  const unitChart = chartsByUnit[unidad];
                  const unitData = ListaIngresadoPorProveedor.filter(item =>
                    (item.UnidadDescripcion || 'Sin unidad') === unidad
                  );

                  // Calcular totales para esta unidad
                  const totalPeso = parseFloat(unitData.reduce((acc, curr) => acc + obtenerCantidadIngreso(curr), 0));
                  return (
                    <div key={`ingresos-${unidad}`} style={{ marginBottom: '30px' }}>


                      {/* Contenedor horizontal para los tres gráficos */}
                      <div
                        className="charts-row"
                        style={{
                          display: 'flex',
                          gap: '5px',
                          alignItems: 'start',
                          justifyContent: 'center',
                          overflowX: 'auto',
                          overflowY: 'hidden',
                          paddingBottom: '10px',
                          width: '100%',
                          height: '420px'
                        }}>
                        {/* Gráfico de barras */}
                        <div className="card chart-barras" style={{ flexShrink: 0, minWidth: '400px', width: '400px' }}>
                          <Chart
                            type="bar"
                            data={unitChart.data}
                            options={unitChart.options}
                            style={{ height: "400px", padding: "5px" }}
                          />
                        </div>

                        {/* Círculos de totales para esta unidad */}
                        <div
                          className="chart-totales"
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px',
                            flexShrink: 0,
                            minWidth: '150px',
                            width: '150px',
                            padding: '15px',
                          
                          }}>
                          <div className="circle-container ingresos-total-circle" style={{ marginTop: 50 }}>
                            <div className="circle-content">
                              <div className="circle-number ingresos-total-number">
                                {parseFloat(totalPeso.toFixed(2))}
                              </div>
                              <div className="circle-label">Total {unidad === 'Sin unidad' ? 'Peso' : unidad}</div>
                            </div>
                          </div>

                        </div>

                        {/* Gráfico de torta para esta unidad */}
                        <div className="grafico-torta">
                          {proveedorPieChartsByUnit[unidad] && (
                            <div className="card" style={{ minHeight: '280px', padding: '10px' }}>
                              <h4 className="titulo-bloque">
                                Distribución por Proveedor - {unidad}
                              </h4>
                              <Chart
                                type="pie"
                                data={proveedorPieChartsByUnit[unidad].peso.data}
                                options={proveedorPieChartsByUnit[unidad].peso.options}
                                style={{ height: "300px", width: "100%", padding: "5px" }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="card">
                  <Chart type="bar" data={chartData} style={{ height: "300px !important", padding: "5px" }} />
                </div>
              )}
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default IngresosReportes;
